import { MapTool } from 'components/maps/LayersToolbar/const';
import { useMemo, useState } from 'react';

export const useActiveMapTool = () => {
  const [activeMapTool, setActiveMapTool] = useState<MapTool>(MapTool.PAN);

  const cursor = useMemo(() => {
    switch (activeMapTool) {
      case MapTool.AREA:
      case MapTool.SEGMENT:
        return 'all-scroll';
      case MapTool.DISTANCE:
        return 'e-resize';
      case MapTool.LASSO:
        return 'crosshair';
      case MapTool.POINT:
        return 'crosshair'; // TODO: show pin
      case MapTool.PAN:
      default:
        return null;
    }
  }, [activeMapTool]);

  const contextValue = useMemo(
    () => ({
      activeMapTool,
      setActiveMapTool,
      cursor,
    }),
    [activeMapTool, setActiveMapTool, cursor]
  );

  return contextValue;
};
